/*
 * @Author: tangf tangf_86@163.com
 * @Date: 2024-03-26 13:52:11
 * @LastEditors: tangf tangf_86@163.com
 * @LastEditTime: 2024-06-05 16:31:27
 * @FilePath: \hippo-web-admin\src\lang\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import locale from 'element-ui/lib/locale';
import VueI18n from 'vue-i18n';
//页面中自定义变量
import en from './en';
import ar from './ar';
import zh from './zh';
import cs from './cs'; // 捷克语
import it from './it';
import sl from './sl';
//ele-admin自带多语言配置
import enLocale from 'ele-admin/packages/lang/en';
import arLocale from 'ele-admin/packages/lang/ar';
import zhLocale from 'ele-admin/packages/lang/zh-CN';
import csLocale from 'ele-admin/packages/lang/cs-CZ';
import itLocale from 'ele-admin/packages/lang/it';
import slLocale from 'ele-admin/packages/lang/sl';
import store from '@/store';

Vue.use(VueI18n);

const messages = {
  en: {
    ...en,
    ...enLocale
  },
  ar: {
    ...ar,
    ...arLocale
  },
  zh: {
    ...zh,
    ...zhLocale
  },
  cs: {
    ...cs,
    ...csLocale
  },
  it: {
    ...it,
    ...itLocale
  },
  sl: {
    ...sl,
    ...slLocale
  }
};
const getDefaultLang = () => {
  const lang = process.env.VUE_APP_THEME == 'hippo' ? 'en' : 'zh';
  const localLang = localStorage.getItem('hippoLang');
  let result = 'en';
  if (lang.indexOf('zh') > -1) result = 'zh';
  if (lang.indexOf('en') > -1) result = 'en';
  if (lang.indexOf('ar') > -1) result = 'ar';
  if (lang.indexOf('cs') > -1) result = 'cs';
  if (lang.indexOf('it') > -1) result = 'it';
  if (lang.indexOf('sl') > -1) result = 'sl';
  localStorage.setItem('hippoLang', localLang || result);
  store.commit('SET_LANGUAGE', localLang || result);
  return localLang || result;
};
const i18n = new VueI18n({
  locale: getDefaultLang(), //从localStorage中拿到用户的语言选择，如果没有，那默认英文。
  messages,
  silentTranslationWarn: true
});
locale.i18n((key, value) => i18n.t(key, value)); //为了实现element插件的多语言切换
export default i18n;
